module.exports = __webpack_public_path__ + "static/img/honor.3480ce7d.png";